import { useTranslation } from "react-i18next";
import { ReactNode } from "react";
import Cookies from "js-cookie";
import { LICENSE_CU_CONTAINER_ID } from "./LicenseAlertContainer";

interface IProps {
    content: ReactNode;
    hideToast?: () => void;
}

const hideFor7Day = () => Cookies.set(`userful-notification-${LICENSE_CU_CONTAINER_ID}`, "hide", { expires: 7 });
const hide = () => Cookies.set(`userful-notification-${LICENSE_CU_CONTAINER_ID}`, "hide", { expires: 365 });

export default function LicenseCUAlertToast({ content, hideToast }: IProps) {
    const { t } = useTranslation();

    const handleHideFor7Day = (e) => {
        e.preventDefault();
        hideFor7Day();
        if (hideToast) hideToast();
    };

    const handleHide = (e) => {
        e.preventDefault();
        hide();
        if (hideToast) hideToast();
    };

    return (
        <div className="notificationContentContainer">
            {content}
            <div className="notificationHideActions">
                <a href="#" onClick={handleHideFor7Day}>
                    {t("Error.hideFor7Day")}
                </a>
                <a href="#" onClick={handleHide}>
                    {t("Error.hideForever")}
                </a>
            </div>
        </div>
    );
}
